<template>
  <div class="form-group col-12 px-0 my-auto">
    <div class="position-relative">
      <div class="d-flex flex-row">
        <label class="text-gray-700"> {{ label }} </label>
      </div>
      <div class="row">
        <div
          v-for="(item, index) in list"
          :key="item.name + index"
          :class="list.length > 2 ? 'col-4' : 'col-6'"
          class="mb-2 mb-md-3"
        >
          <button
            type="button"
            class="btn btn-tertiary mb-sm-0 w-100 fw-bold"
            :disabled="inputDisabled"
            :class="{
              'text-gray-400': inputDisabled,
              'bg-blue-400': inputDisabled && isSelected(item),
              'active': isSelected(item),
              'mb-3': index === list.length - 1
            }"
            @click="!inputDisabled && !isSelected(item) ? setCustomModel(item) : null"
          >
            {{ item.name }}
            <v-icon
              v-if="item.icon"
              :icon="item.icon"
              class="position-absolute"
              style="right: 15%; top: 50%; transform: translate(0, -50%);"
            />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { transform } from '@/mixins';

import input from '@/mixins/input-2';

export default {
  name: 'InputRadioTwo',
  mixins: [transform, input],
  props: {
    list: {
      type: Array,
      required: true,
      default: () => [],
    },
    isSelectedFunction: {
      type: [Function, null],
      default: null,
    },
  },
  methods: {
    isSelected(item) {
      if (this.isSelectedFunction) {
        return this.isSelectedFunction(item);
      }
      if (this.customValue !== null) {
        return item.value === this.customValue || item.value === this.customValue.value;
      }
      if (item && item.value) {
        return item.value === this.customValue;
      }
      return false;
    },
  },
};
</script>
